import Api from 'utils/ApiRequest';
import API_URL from 'constants/api';
import { actionSet } from './utils';
import { getPages } from 'component/pagination/utils';
import { FETCH_PRICE_AUDIT_REPORT_REQUEST, FETCH_PRICE_AUDIT_REPORT_SUCCESS, FETCH_PRICE_AUDIT_REPORT_ERROR, } from 'actionTypes';
import { hideSpinner, showSpinner } from './spinner';
import { PriceAuditType } from 'utils/Enums';
import moment from 'moment';
export var priceAuditTypeFromStatusCode = function (statusCode) { return PriceAuditType[statusCode - 1]; };
export var fetchFluxGraphData = function (token, param, callback, signalController) { return function (dispatch) {
    param.priceAuditType = priceAuditTypeFromStatusCode(param.priceAuditTypeCode);
    param.dtStart = moment(param.dtStart).format('L');
    param.dtEnd = moment(param.dtEnd).format("L");
    var onClose = function () {
        dispatch(hideSpinner());
        dispatch(hideSpinner());
    };
    var onError = function (error) {
        dispatch(actionSet(FETCH_PRICE_AUDIT_REPORT_ERROR, error));
        onClose();
    };
    var onMessage = function (response) {
        dispatch(getPages(response.data.pages));
        if (callback) {
            callback({ sections: response.data.priceAuditChartSections, stores: response.data.priceAuditChartStores });
        }
        onClose();
    };
    var abort = function () {
        signalController.abort();
        dispatch(hideSpinner());
        dispatch(hideSpinner());
    };
    dispatch(showSpinner("", true, abort));
    return new Api(token, dispatch)
        .eventSourceStream(API_URL.GET_GRAPH_DATA, param, null, signalController, onMessage, onClose, onError)
        .catch(function (error) { return onError(error); });
}; };
export var fetchFlux = function (token, param, callback, signalController) { return function (dispatch) {
    param.priceAuditType = priceAuditTypeFromStatusCode(param.priceAuditTypeCode);
    param.dtStart = moment(param.dtStart).format('L');
    param.dtEnd = moment(param.dtEnd).format("L");
    var onClose = function () {
        dispatch(hideSpinner());
        dispatch(hideSpinner());
    };
    var onError = function (error) {
        dispatch(actionSet(FETCH_PRICE_AUDIT_REPORT_ERROR, error));
        onClose();
    };
    var onMessage = function (response) {
        dispatch(getPages(response.data.pages));
        dispatch(actionSet(FETCH_PRICE_AUDIT_REPORT_SUCCESS, response.data.priceAuditReport));
        if (callback) {
            callback(response.data.priceAuditReport, response.data.pages.totalCount, { sections: response.data.priceAuditChartSections, stores: response.data.priceAuditChartStores });
        }
        onClose();
    };
    var abort = function () {
        signalController.abort();
        dispatch(hideSpinner());
        dispatch(hideSpinner());
    };
    dispatch(showSpinner("", true, abort));
    return new Api(token, dispatch)
        .eventSourceStream(API_URL.FETCH_PRICE_AUDIT, param, null, signalController, onMessage, onClose, onError)
        .catch(function (error) { return onError(error); });
}; };
export var fetch = function (token, param, callback) { return function (dispatch) {
    param.priceAuditType = priceAuditTypeFromStatusCode(param.priceAuditTypeCode);
    param.dtStart = moment(param.dtStart).format('L');
    param.dtEnd = moment(param.dtEnd).format("L");
    dispatch(actionSet(FETCH_PRICE_AUDIT_REPORT_REQUEST));
    return new Api(token, dispatch)
        .post(API_URL.FETCH_PRICE_AUDIT, param)
        .then(function (response) {
        dispatch(getPages(response.data.pages));
        dispatch(actionSet(FETCH_PRICE_AUDIT_REPORT_SUCCESS, response.data.priceAuditReport));
        if (callback) {
            callback(response.data.priceAuditReport, response.data.pages.totalCount, { sections: response.data.priceAuditChartSections, stores: response.data.priceAuditChartStores });
        }
    })
        .catch(function (error) {
        dispatch(actionSet(FETCH_PRICE_AUDIT_REPORT_ERROR, error));
        dispatch(hideSpinner());
    })
        .finally(function () { });
}; };
